module.exports = __webpack_public_path__ + "img/pingan_entry_bg.8686485d.jpg";